import { useMeta, useContext } from '@nuxtjs/composition-api';
import { isEmpty } from 'lodash';
import { isVideoCategory } from '@/modules/category/utils/categoryHelpers';
import { mergeHeadItems } from '~/modules/common/utils/helpers';
import { getLinkMeta, getMetaOpenGraph, getMetaTwitter } from '~/modules/common/utils/metaUtils';

import {
  generateBreadcrumbSchema,
  generateCategorySchema,
  generateNewsMediaOrganizationSchema,
  generateVideoCategorySchema,
  generateWebPageSchema,
  generateWebsiteSchema,
  getSchemaHead,
} from '~/modules/common/utils/schemaUtils';
import { LINK_PROD } from '~/constants/config';

export function useCategoryMeta({ category, pagination, breadcrumb, feed }) {
  const { i18n } = useContext();
  const { link } = getLinkMeta();
  const metaInit = [];
  useMeta(() => {
    if (isEmpty(category) || isEmpty(pagination.value) || isEmpty(breadcrumb)) return;
    // title
    const title = category.title
      ? `${category.title} ${pagination.value.page > 1 ? ` - ${i18n.t('main.page')} ${pagination.value.page}` : ''}`
      : '';
    // description
    const description = category.description
      ? `${category.description} ${pagination.value.page > 1 ? ` - ${i18n.t('main.page')} ${pagination.value.page}` : ''}`
      : '';
    // meta open graph
    const metaOpeGraph = getMetaOpenGraph({
      url: link[0].href,
      ...(description.length && { description }),
      title,
    });
    // meta twitter
    const metaTwitter = getMetaTwitter({ url: link[0].href, description, title });
    if (description.length) {
      metaInit.push({ hid: 'description', name: 'description', content: description });
    }
    const meta = [...metaInit, ...metaOpeGraph, ...metaTwitter];
    // category schemas
    const websiteSchema = generateWebsiteSchema();
    const newsMediaOrganization = generateNewsMediaOrganizationSchema();
    const webPageSchema = generateWebPageSchema({ headline: category.name, description });
    // breadcrumb schema
    const breadcrumbs = [{ url: LINK_PROD, name: i18n.t('main.homepage') }];
    breadcrumb.forEach((item) => {
      breadcrumbs.push({ url: `${LINK_PROD}${item.href}`, name: item.name });
    });
    const breadcrumbSchema = generateBreadcrumbSchema(breadcrumbs);

    let categoryListSchema = null;
    if (!isEmpty(feed.value)) {
      categoryListSchema = isVideoCategory(category._id) ? generateVideoCategorySchema(feed.value) : generateCategorySchema(feed.value);
    }

    return mergeHeadItems(
      getSchemaHead(websiteSchema),
      getSchemaHead(newsMediaOrganization),
      getSchemaHead(webPageSchema),
      getSchemaHead(breadcrumbSchema),
      getSchemaHead(categoryListSchema),
      { title },
      { link },
      { meta }
    );
  });
}
